'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

var _components = require('components');

var _moduleData = require('redux/modules/moduleData');

var moduleActions = _interopRequireWildcard(_moduleData);

var _modules = require('redux/modules/modules');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var YES = 'Yes';
var NO = 'No';

// https://www.kirupa.com/react/transferring_properties.htm
// http://stackoverflow.com/questions/36631761/when-should-i-add-redux-to-a-react-app
var Module0App1 = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user,
    app: state.moduleData.data.module0.app1,
    profile: state.profile.data,
    allModule: state.moduleData.data.module1
  };
}, (0, _extends3.default)({}, moduleActions, { changeItem: _modules.changeItem })), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Module0App1, _Component);

  function Module0App1() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Module0App1);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Module0App1.__proto__ || (0, _getPrototypeOf2.default)(Module0App1)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      moduleId: 1,
      appId: 1,
      seen: _this.props.app.seen || '',
      diet: _this.props.app.diet || '',
      dietInvolve: _this.props.app.dietInvolve || '',
      isCompleted: _this.props.app.isCompleted || false
    }, _this.handleSeen = function (event) {
      var obj = _this.state;
      obj.seen = event.target.value;

      if (event.target.value === NO) {
        obj.diet = '';
        //obj.isCompleted = false;
      }

      _this.setState(obj);
    }, _this.handleDiet = function (event) {
      var obj = _this.state;
      obj.diet = event.target.value;
      _this.setState(obj);
    }, _this.handleChange = function (str, event) {
      var obj = _this.state;
      obj[str] = event.target.value;
      _this.setState(obj);
    }, _this.handleComplete = function () {
      var obj = _this.state;
      var numAppCompleted = _this.props.allModule.numAppCompleted;

      // if its not completed, we increase numAppCompleted
      if (!obj.isCompleted) {
        numAppCompleted++;
      }

      obj.isCompleted = true;
      _this.setState(obj);

      // update the actual app
      // this.props.updateModuleApp(this.props.user.userId, this.state.moduleId, this.state.appId, this.state);
      _this.props.updateModuleApp(_this.props.user.userId, 0, 1, _this.state);

      // update the overarching module's details
      _this.props.updateModule(_this.props.user.userId, _this.state.moduleId, {
        'numAppCompleted': numAppCompleted,
        'numAppTotal': _this.props.allModule.numAppTotal });

      _this.props.changeItem(_this.state.moduleId, 0, _this.state.appId + 1);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  /*
   * User clicks on Yes or No for have they
   * seen a dietician
   */


  /*
   * User clicks on Yes or No for have they
   * have they been involved in any other kind of diet
   * related study
   */


  /*
   * User types in something for what was
   * involved in the diet
   */


  /*
   * Handle when user finishes this module
   */


  (0, _createClass3.default)(Module0App1, [{
    key: 'render',
    value: function render() {
      var styles = require('../../Modules.scss');

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: styles.activityPanel },
          _react2.default.createElement(
            'div',
            { className: styles.title },
            _react2.default.createElement(
              'h3',
              null,
              'Getting Ready'
            ),
            _react2.default.createElement(
              'h2',
              null,
              'What do you already know?'
            )
          ),
          _react2.default.createElement('div', { className: styles.spacer20 }),
          _react2.default.createElement(
            ReactBootstrap.Row,
            null,
            _react2.default.createElement(
              ReactBootstrap.Col,
              { md: 2, lg: 2 },
              '\xA0'
            ),
            _react2.default.createElement(
              ReactBootstrap.Col,
              { md: 10, lg: 10, sm: 12, xs: 12 },
              _react2.default.createElement('iframe', { src: 'https://player.vimeo.com/video/233838377', width: '640', height: '360', frameBorder: '0', allowFullScreen: true }),
              _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                  'a',
                  { href: 'https://vimeo.com/233838377' },
                  'Reboot kids live'
                ),
                ' from ',
                _react2.default.createElement(
                  'a',
                  { href: 'https://vimeo.com/rebootkids' },
                  'Reboot Kids'
                ),
                ' on ',
                _react2.default.createElement(
                  'a',
                  { href: 'https://vimeo.com' },
                  'Vimeo'
                ),
                '.'
              )
            ),
            _react2.default.createElement(
              ReactBootstrap.Col,
              { md: 2, lg: 2 },
              '\xA0'
            )
          ),
          _react2.default.createElement('div', { className: styles.spacer20 }),
          _react2.default.createElement(
            'h5',
            null,
            'Have you seen a dietitian, nutritionist or other health professional about ',
            this.props.profile.childName,
            '\'s diet previously?'
          ),
          _react2.default.createElement(
            ReactBootstrap.FormGroup,
            { onChange: this.handleSeen },
            _react2.default.createElement(
              ReactBootstrap.Radio,
              { name: 'seen', value: 'Yes', checked: this.state.seen === 'Yes' || this.state.seen == 1 },
              'Yes'
            ),
            _react2.default.createElement(
              ReactBootstrap.Radio,
              { name: 'seen', value: 'No', checked: this.state.seen === 'No' || this.state.seen == 0 },
              'No'
            )
          ),
          (this.state.seen === NO || this.state.seen == 0) && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'h5',
              null,
              'Have you been involved in any other kind of diet related study?'
            ),
            _react2.default.createElement(
              ReactBootstrap.FormGroup,
              { onChange: this.handleDiet },
              _react2.default.createElement(
                ReactBootstrap.Radio,
                { name: 'diet', value: 'Yes', checked: this.state.diet === 'Yes' || this.state.diet == 1 },
                'Yes'
              ),
              _react2.default.createElement(
                ReactBootstrap.Radio,
                { name: 'diet', value: 'No', checked: this.state.diet === 'No' || this.state.diet == 0 },
                'No'
              )
            )
          ),
          (this.state.seen === NO || this.state.seen == 0) && (this.state.diet === YES || this.state.diet == 1) && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'h5',
              null,
              'What did the diet related study involve?'
            ),
            _react2.default.createElement(
              ReactBootstrap.FormGroup,
              null,
              _react2.default.createElement(ReactBootstrap.FormControl, { type: 'text', placeholder: 'My diet related study involved...',
                value: this.state.dietInvolve, onChange: this.handleChange.bind(this, 'dietInvolve') })
            )
          ),
          _react2.default.createElement(_components.FinishTaskButton, { onChange: this.handleComplete }),
          _react2.default.createElement('div', { className: styles.spacer100 })
        )
      );
    }
  }]);
  return Module0App1;
}(_react.Component), _class2.propTypes = {
  allModule: _propTypes2.default.object,
  app: _propTypes2.default.object,
  profile: _propTypes2.default.object,
  user: _propTypes2.default.object,
  updateModuleApp: _propTypes2.default.func,
  updateModule: _propTypes2.default.func,
  changeItem: _propTypes2.default.func.isRequired
}, _temp2)) || _class);
exports.default = Module0App1;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/0/App/App1.js
// module id = 1153
// module chunks = 0